import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import groupType from '../proptypes/group';
import normaliseGroup from '../selectors/normalise-group';
import { ssColorCyan } from '../constants/style-constants';

const onChange = ({ target: { value } }) => {
  const url = new URL(window.location.href);

  url.searchParams.set('profile-to-compare', value);
  window.location.assign(url.toString());
};

const renderOptions = group => (
  group.map(({ profile: { id, fullName } }) => (
    <option value={id} key={id}>{fullName}</option>
  ))
);

const PickerSelectCSS = css`
  background-color: transparent;
  border: 1px solid ${ssColorCyan};
`;

const ComparisonPicker = ({ profileToCompareId, group, noFullNameAvailableFallback }) => {
  const groupWithFallbackNames = normaliseGroup({ group, noFullNameAvailableFallback });

  return (
    <div className="row">
      <div className="col-md-5">
        <select className="custom-select" defaultValue={profileToCompareId} onChange={onChange} css={PickerSelectCSS}>
          { renderOptions(groupWithFallbackNames) }
        </select>
      </div>
    </div>
  );
};

ComparisonPicker.propTypes = {
  profileToCompareId: PropTypes.string.isRequired,
  group: groupType.isRequired,
  noFullNameAvailableFallback: PropTypes.string.isRequired,
};

export default ComparisonPicker;
